// Match the English UI while leaving the time zone local to the reader.
const jobDateFormatter = new Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
});

export default function formatJobDate(created: string): string {
  const date = new Date(created);
  // Preserve malformed server values instead of letting Intl unmount the page.
  return Number.isNaN(date.getTime()) ? created : jobDateFormatter.format(date);
}
